module.exports={render:function (){with(this) {
  return _h('div', [_h('div', {
    staticClass: "nav"
  }, [_h('router-link', {
    attrs: {
      "to": "/home"
    }
  }, ["Home"]), " ", _h('router-link', {
    attrs: {
      "to": "/hello"
    }
  }, ["Hello"])]), " ", _h('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_h('keep-alive', [_h('router-view', {
    staticClass: "view"
  })])])])
}},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-21c1ac74!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 7
// module chunks = 0